define.alias("ember-power-select/components/power-select-multiple", "calendar/components/power-select-multiple");